import { inject, Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  LocalStorageService,
  JWT_TOKEN_LS_KEY,
  JWT_REFRESH_TOKEN_LS_KEY,
} from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class JwtAuthService {
  private readonly http = inject(HttpClient);
  private readonly ls = inject(LocalStorageService);
  private apiUrl = environment.apiUrl;

  isLoggedin() {
    return !!this.ls.getItem(JWT_TOKEN_LS_KEY);
  }

  logout(callback: () => void) {
    this.http.post(`${this.apiUrl}auth/logout`, {}).subscribe(() => {
      this.ls.clearAuth();
      callback();
    });
  }

  setUserToken(token: string) {
    this.ls.setItem(JWT_TOKEN_LS_KEY, token);
  }
  setRefreshToken(token: string) {
    this.ls.setItem(JWT_REFRESH_TOKEN_LS_KEY, token);
  }
}
